'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { FC, PropsWithChildren, useContext, useEffect } from 'react';

import { GlobalModalContext } from '@abg/web-core/context/global-modal';

import { userStoreSelector } from '../../store/user';

export const InitialLoginModalCheck: FC<PropsWithChildren> = ({ children }) => {
  const { openModal } = useContext(GlobalModalContext);
  const router = useRouter();
  const searchParams = useSearchParams();
  const isGuest = userStoreSelector.use.isGuest();
  const userSession = userStoreSelector.use.userSession();

  useEffect(() => {
    const loginParameter = searchParams.get('login');

    if (loginParameter && userSession) {
      if (isGuest) {
        openModal('login-modal');
      }

      const currentParams = new URLSearchParams(searchParams.toString());

      currentParams.delete('login');

      const newQueryString = currentParams.toString();

      router.replace(
        `${globalThis?.location.pathname}${newQueryString ? `?${newQueryString}` : ''}`,
      );
    }
  }, [isGuest, router, searchParams, userSession, openModal]);

  return children;
};
